module.exports = __webpack_public_path__ + "img/project1.356bf52c.png";